import { useEffect, useState } from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import DetailsDialog, { DetailsProps } from "../DetailsDialog";
import { Identifiable } from "../../model/Items";
import NumberInputField from "../ui/NumberInputField";
import { Pricing } from "../../api/PricingApi";
import useMaterialApi, { Material } from "../../api/MaterialApi";

interface Props extends DetailsProps {
  customerId: number;
  priceListId: number;
}

const sortByName = (material: Material, anotherMaterial: Material) => material.name.localeCompare(anotherMaterial.name);

const PricingDetails = (props: Props) => {
  const materialApi = useMaterialApi();
  const [materials, setMaterials] = useState<Material[]>();
  const [material, setMaterial] = useState<Identifiable|undefined>();
  const [unitPrice, setUnitPrice] = useState<number>();

  const initializeFields = (data: Pricing) => {
    setMaterial({ id: data.material.id })
    setUnitPrice(data.unitPrice);
  };

  const collectData = (): Pricing|null =>
    (material && unitPrice)
      ? {
        material: { id: material.id },
        unitPrice,
      }
      : null;

  const handleMaterialChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const selectedMaterial = event.target.value as Identifiable;
    setMaterial(selectedMaterial);
  };

  const renderFields = (initialData: Pricing|undefined) => (
    <>
      <h2>Wprowadź cenę materiału</h2>
      {materials && <FormControl>
        <InputLabel>Materiał</InputLabel>
        <Select value={material || ''} onChange={handleMaterialChange}>
          {materials.map(material => (<MenuItem value={material as any}>{material.name}</MenuItem>))}
        </Select>
      </FormControl>}
      <NumberInputField
        label='Cena jednostkowa'
        autoFocus
        initialValue={initialData?.unitPrice}
        onValueChange={setUnitPrice} />
    </>
  );

  const fetchMaterialsAndSortByName = () => {
    materialApi
      .fetchMaterials()
      .then(data => setMaterials(data.sort(sortByName)))
      .catch(reason => console.error(`Could not fetch materials: ${reason}`));
  };

  useEffect(fetchMaterialsAndSortByName, []);

  useEffect(() => {
    if (materials && material) {
      setMaterial(materials.find(item => item.id === material.id));
    }
  }, [materials, material]);

  return (
    <DetailsDialog<Pricing>
      { ...props }
      resource={`customers/${props.customerId}/price-lists/${props.priceListId}/material-prices`}
      renderFields={renderFields}
      initializeFields={initializeFields}
      collectData={collectData}
    />
  );
};
export default PricingDetails;